module.exports = __webpack_public_path__ + "static/img/naniungo_dach.310c9708.png";